<template>
  <div id="surface-header"
       :class="['app-bar', 'surface-header']"
       :data-luminance="realBackgroundLuminance"
       :style="{ 'background-color': realBackgroundColor }">
    <div class="rubber-band-scroll-padder" :style="{ 'background-color': backgroundColor }" />
    <surface-nav v-if="xNav" />
    <surface-title @title-changed="updateHeaderHeight"
                   @description-changed="updateHeaderHeight" />
  </div>
</template>

<script>
import SurfaceNav from 'vuecomponents/surface_nav'
import SurfaceTitle from 'vuecomponents/surface_title'
import {
  getNotificationPermission,
  registerForPushNotifications,
} from 'bits/notifications'
import { __ } from 'bits/intl'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: { SurfaceNav, SurfaceTitle },
  computed: {
    ...mapGetters(['backgroundColor', 'backgroundLuminance', 'colorScheme', 'isBackchannel', 'isMap', 'amIRegistered']),
    ...mapState(['user']),
    xNav () {
      return !this.$store.isApp
    },
    realBackgroundColor () {
      if (this.isMap) {
        return this.colorScheme === 'light' ? '#FFFFFF' : '#000000'
      }
      return this.backgroundColor
    },
    realBackgroundLuminance () {
      if (this.isMap) {
        return this.colorScheme
      }
      return this.backgroundLuminance
    },
  },
  mounted () {
    // Don't prompt for notifications if the user is not registered
    if (this.amIRegistered) {
      // check if user is registered before displaying
      getNotificationPermission().then(permission => {
        if (permission === 'default' || permission === 'granted') {
          registerForPushNotifications(this.user).catch(e => {
            console.warn(`No push`, e)
          })
        } else {
          // this.showNotificationsSnackbar()
        }
      })
    }
    this.updateHeaderHeight()
  },
  methods: {
    ...mapActions('snackbars', ['setSnackbar']),
    ...mapActions(['resizeHeader']),
    updateHeaderHeight () {
      this.$nextTick(() => {
        this.resizeHeader({ height: this.$el.offsetHeight })
      })
    },
    showNotificationsSnackbar () {
      const message = __('Notifications disabled on this browser. Turn on?')
      const actionText = __('OK')
      const actionName = 'showPermitNotification'
      this.setSnackbar({ message, actionText, actionName, persist: true })
    },
  },
}
</script>

<style>
.rubber-band-scroll-padder {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: -100vh;
}
</style>
